module.exports = __webpack_public_path__ + "img/zeno-5.5a034b3c.jpg";